<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div id="card-config">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Character Selection</mat-card-title>
    </mat-card-header>
    <mat-card-content id="content-char-selection">
      <app-desired-class-selection></app-desired-class-selection>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Select your desired stat distribution</mat-card-title>
      <mat-card-subtitle> Select the stats one by one using the sliders below. </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-desired-stat-selection></app-desired-stat-selection>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Armor Selection</mat-card-title>
      <mat-card-subtitle>
        This section allows you to limit the armor pieces that are used in the buildcrafting
        process.<br />
        If you want, limit all results to one exotic. <br />
        Exotics you do not have in the inventory or vault are grayed out.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-desired-exotic-selection></app-desired-exotic-selection>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Gearset selection and Mod limitation</mat-card-title>
      <mat-card-subtitle>
        This section allows you to further specify what kind of armor and mods you want.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-desired-mod-selection></app-desired-mod-selection>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Stat-Boost Selection</mat-card-title>
      <mat-card-subtitle>
        Select Mods and Skills that affect your overall stats.<br />
        Please note that D2AP also allows theoretical, but impossible input.<br />
        <b>Only fragments that affect stats are shown.</b>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-desired-mods-selection></app-desired-mods-selection>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Advanced Settings</mat-card-title>
      <mat-card-subtitle>
        More settings! Use them to fine-tune your buildcrafting process.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-advanced-settings></app-advanced-settings>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Disabled Armor Pieces</mat-card-title>
      <mat-card-subtitle>
        These armor pieces are disabled. Click them to enable them again.<br />
        They won't show up in any results.<br />
        You can disable items in the detailed result overview.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-ignored-items-list></app-ignored-items-list>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Configuration Management</mat-card-title>
      <mat-card-subtitle>
        Save and load your buildcrafting settings for another day!
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-load-and-save-settings></app-load-and-save-settings>
    </mat-card-content>
  </mat-card>
</div>
